import { render, staticRenderFns } from "./ModelMng.vue?vue&type=template&id=6e0664b6"
import script from "./ModelMng.vue?vue&type=script&lang=js"
export * from "./ModelMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports